import { module } from 'angular';
import templateBuilderPasswordDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/password/display.html', templateBuilderPasswordDisplay);
});
